import * as v from 'valibot'

/**
 * Helper function to create TanStack Form validator from Valibot schema
 */
export function createValibotValidator<T>(schema: v.BaseSchema<unknown, T, v.BaseIssue<unknown>>) {
  return {
    onChange: ({ value }: { value: unknown }) => {
      const result = v.safeParse(schema, value)
      if (!result.success) {
        // Return first error message
        return result.issues[0]?.message || 'Validation error'
      }
      return undefined
    },
  }
}

/**
 * Create field-specific validator from object schema
 */
export function createFieldValidator<
  T extends v.ObjectEntries
>(
  schema: v.ObjectSchema<T, undefined>,
  fieldName: keyof T,
) {
  const fieldSchema = schema.entries[fieldName]
  return createValibotValidator(fieldSchema)
}
